module.exports = __webpack_public_path__ + "static/media/premium-sprite.cf3bb926.svg";